__turbopack_context__.v({
  "carousel": "BlockVideoCarousel-module-scss-module__4grT8q__carousel",
  "flushBottom": "BlockVideoCarousel-module-scss-module__4grT8q__flushBottom",
  "flushTop": "BlockVideoCarousel-module-scss-module__4grT8q__flushTop",
  "item": "BlockVideoCarousel-module-scss-module__4grT8q__item",
  "root": "BlockVideoCarousel-module-scss-module__4grT8q__root",
  "slide": "BlockVideoCarousel-module-scss-module__4grT8q__slide",
});
